import axios from 'axios';
import { store } from '../store';

// export const getTranslationSites = () => {
//   const state = store.getState();
//   const { token } = state.auth;
//   axios({
//     url: `${process.env.REACT_APP_MMB_API_URL}/api/config/site/list/`,
//     headers: { Authorization: `Token ${token}` },
//   }).then(({ data }) => {
//     store.dispatch({ type: 'LOAD_TRANSLATION_SITES', payload: data });
//   });
// };

export const loadTranslationsBySite = (hash, site) => new Promise((resolve, reject) => {
  axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/config/translation/`,
    params: { hash, site },
  }).then(({ data }) => {
    store.dispatch({ type: 'LOAD_TRANSLATIONS', payload: { ...data } });
    resolve();
  }).catch((err) => {
    reject(err);
  });
});

/**
 * Check for any published translations updates.
 */
export const validateTranslations = (site) => new Promise((resolve, reject) => {
  axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/config/translation/`,
    params: { site },
  }).then(({ data }) => {
    const current = store.getState().translations.hash;
    const { hash } = data;

    if (hash !== current) {
      loadTranslationsBySite(hash, site).then(() => {
        resolve();
      });
    } else {
      store.dispatch({ type: 'LOADING_TRANSITION_OBJECT', payload: false });
    }
  }).catch((err) => {
    reject(err);
  });
});

/**
 * Update translations.
 */
export const updateTranslations = (tab, title, section, formSection, newValue) => {
  store.dispatch({
    type: 'UPDATE_TRANSLATION_OBJECT',
    payload: {
      tab,
      title,
      section,
      formSection,
      newValue,
    },
  });
};

/**
 * Save updated translations.
 */
export const saveUpdatedTranslations = (data, site, del, add) => {
  const { token } = store.getState().auth;
  if (del) {
    store.dispatch({ type: 'DELETING_LANGUAGE', payload: true });
  } else if (add) {
    store.dispatch({ type: 'ADDING_LANGUAGE', payload: true });
  } else {
    store.dispatch({ type: 'SAVING_TRANSITION_OBJECT', payload: true });
  }

  return new Promise((resolve, reject) => {
    axios({
      method: 'put',
      url: `${process.env.REACT_APP_MMB_API_URL}/api/config/translation/update/`,
      headers: { Authorization: `Token ${token}` },
      params: { site },
      data,
    }).then(() => {
      store.dispatch({ type: 'LOAD_TRANSLATIONS', payload: data });
      store.dispatch({ type: 'SAVING_TRANSITION_OBJECT', payload: false });
      store.dispatch({ type: 'EDIT_TRANSITION_OBJECT', payload: false });
      store.dispatch({ type: 'DELETING_LANGUAGE', payload: false });
      store.dispatch({ type: 'ADDING_LANGUAGE', payload: false });
      resolve();
    }).catch((err) => {
      reject(err);
    });
  });
};
